import i18n from 'i18next';
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from 'react-i18next';


i18n
.use(LanguageDetector)
.use(initReactI18next) // passes i18n down to react-i18next
.init({
    resources: {
        en: {
            "translations": {
                "textselectlanguage": "Please select language",
                "SelectNext": "Next",
                "SelectPrevious": "Previous",
                "SelectionOf": "Selection of ",

            }
        },
        de: {
            "translations": {
                "textselectlanguage": "Bitte eine Sprache wählen",
                "SelectNext": "Weiter",
                "SelectPrevious": "Zurück",
                "SelectionOf": "Auswahl von ",
   
            }
        }

    },
    //lng: "en",
    fallbackLng: "en",
    debug: true,
    ns: ["translations"],
    defaultNS: "translations",
    keySeparator: ".",
    interpolation: {
        escapeValue: false,
        formatSeparator: ",",
        format: (value, format, lng) => {
            if (format === 'formattedFloat') {
                return Intl.NumberFormat(lng).format(value.toFixed(1));
            }
            return value;
            }        
    },
    react: {
        useSuspense: false,
        wait: true,
        bindI18n: 'languageChanged loaded',
        bindStore: 'added removed',
        nsMode: 'default'
    }
})


// i18n.changeLanguage();   // no parameter, will use language detector ???

export default i18n;
